import { Blok } from '@app/typings/blok'

export const getBlokContent = (block: Blok[]) => {
  if (!block || block.length === 0) {
    return {}
  }

  if (block[0].component !== 'global-reference') {
    return block[0]
  }

  // check that reference is resolved before returning the data
  else if (block[0].reference.content) {
    return block[0].reference.content.global[0]
  }

  return {}
}
